<template>
  <el-dialog
    :visible="visible"
    class="responsive product-barcode-modal"
    width="520px"
    :close-on-click-modal="false"
    @opened="renderBarcode"
    @close="handleClose"
  >
    <span slot="title" style="font-size: 16px">
      Mã vạch<span v-if="productName">: <strong>{{ productName }}</strong></span>
    </span>
    <div class="barcode-content">
      <div v-if="renderingError" class="barcode-error">
        Không thể hiển thị mã vạch
      </div>
      <div v-else class="barcode-wrapper">
        <svg ref="barcode" class="barcode-svg"></svg>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  name: "ProductBarcodeModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    barcode: {
      type: [String, Number],
      default: "",
    },
    productName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      renderingError: false,
    };
  },
  watch: {
    barcode() {
      if (this.visible) {
        this.$nextTick(this.renderBarcode);
      }
    },
  },
  methods: {
    renderBarcode() {
      const value = String(this.barcode || "").trim();
      this.renderingError = !value;
      if (!value || !this.$refs.barcode) return;

      try {
        JsBarcode(this.$refs.barcode, value, {
          format: "CODE128",
          width: 2,
          height: 90,
          margin: 10,
          fontSize: 22,
          displayValue: true,
        });
        this.renderingError = false;
      } catch (error) {
        this.renderingError = true;
        console.error("Error rendering product barcode", error);
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.product-barcode-modal >>> .el-dialog__body {
  padding-top: 16px;
}

.barcode-content {
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.barcode-wrapper {
  max-width: 100%;
  overflow-x: auto;
  text-align: center;
}

.barcode-svg {
  display: block;
  max-width: none;
  margin: 0 auto;
}

.barcode-error {
  color: #f56c6c;
  text-align: center;
}
</style>
